// Client-side redirects map. Used by Redirector mounted in App.
//
// Add an entry whenever a public URL changes. Catches:
//   - Renamed marketing pages (so old links / inbound search results don't 404)
//   - Common typos that aren't worth a SuggestRoutes pass
//   - Cross-redirects after a content reorg
//
// Server-side 301s (in nginx / hosting config) are still the gold standard
// for SEO equity transfer. This client-side fallback covers what the host
// hasn't been configured for and works while a 301 rule is pending.
//
// Format: { fromPath: { to: '/new/path', status: 'permanent' | 'temporary' } }
// `status` is metadata for analytics + a future hosting-rule generator.

export const REDIRECTS = {
  // Examples — empty by default; add real renames as they happen.
  // '/services':                    { to: '/digital-transformation', status: 'permanent' },
  // '/sap-on-aws':                  { to: '/case-studies/trident-sap-aws-migration', status: 'permanent' },
  // '/blog/old-slug':               { to: '/blog/new-slug', status: 'permanent' },
};

// Normalises trailing slashes + case so '/Contact/' and '/contact' both hit
// the same map entry.
const normalisePath = (path) => {
  if (!path) return '/';
  let p = String(path).toLowerCase();
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
  return p;
};

export const lookupRedirect = (path) => {
  const target = REDIRECTS[normalisePath(path)];
  if (!target) return null;
  return typeof target === 'string' ? { to: target, status: 'permanent' } : target;
};
